module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds@2x.c22c3c0.webp";